/**
 * Per-grade cluster (`6 mastered · 3 improved · 1 weak`) — ROUTE_INVENTORY
 * §2.11 #19.
 *
 * Words, not the `M6 I3 W1` codes it used to print at 9px: the letters had
 * no legend anywhere, and on a phone there is no hover to reveal the title.
 *
 * Zero counts are DROPPED, so a perfect run reads as `10 mastered` rather
 * than `10 mastered · 0 improved · 0 weak`. That is the whole rule: the
 * cluster is a summary, and parts that say nothing are noise.
 *
 * Its own file rather than a block inside `HistoryRow` because the three tones
 * are a colour SET, and a set is what a contrast check has to see at once —
 * four importance tiers storied side by side is how Phase 7 found a 2.04:1
 * label that had looked fine one state at a time.
 */
export function BreakdownPills({
  mastered,
  improved,
  weak,
}: {
  mastered: number;
  improved: number;
  weak: number;
}) {
  return (
    <span className='ml-auto inline-flex flex-wrap items-center justify-end gap-x-1.5 tabular-nums'>
      {mastered > 0 && (
        <span
          title={`${mastered} mastered`}
          className='inline-flex items-center text-xs font-medium text-emerald-700 dark:text-emerald-400'
        >
          {mastered} mastered
        </span>
      )}
      {improved > 0 && (
        <span
          title={`${improved} improved`}
          className='inline-flex items-center text-xs font-medium text-brand-700 dark:text-primary'
        >
          {improved} improved
        </span>
      )}
      {weak > 0 && (
        <span
          title={`${weak} weak`}
          className='inline-flex items-center text-xs font-medium text-rose-700 dark:text-rose-400'
        >
          {weak} weak
        </span>
      )}
    </span>
  );
}
